<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="false" contentStyleClass="pt-2">
    <div class="flex flex-col items-center text-center p-6 space-y-4">
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />


        <div class="bg-custom-blue rounded-full h-[90px] w-[90px]  flex items-center justify-center">
            <i class="fas fa-check text-white custom-thick-icon  fa-3x"></i>
        </div>

        <div class="mb-6">
            <h2 class=" text-3xl font-semibold mt-2">Payment Successful!</h2>
        </div>


        <ng-template [ngTemplateOutlet]="isPurchaseItem"></ng-template>


        <div class="w-full pt-4">
            <button pButton class="p-button-info rounded-lg w-full mt-10 flex items-center justify-center gap-2 mt-6"
                [rounded]="true" (click)="goAfterThankYou()">
                <i class="fa-solid fa-circle-check "></i>
                <span class="flex-1 text-center font-medium font-mulish text-base">Done</span>
            </button>
        </div>
    </div>


    <ng-template #isPurchaseItem>
        <div class="mt-10 pt-6 w-[300px]">

            <div *ngFor="let line of thankYouPageDataSignal()?.lines" class="flex justify-between items-start gap-3">

                <p class=" text-sm font-semibold font-mulish text-start" style="color: var(--panorama-gray);">
                    {{line.quantity}} {{line.name}}</p>
                <span class="font-semibold font-mulish text-black text-lg">
                    ${{line.value.toFixed(2)}}
                </span>

            </div>
            <div class="flex justify-between items-center pb-6  border-b border-gray-200 ">
                <span class="text-sm font-semibold font-mulish" style="color: var(--panorama-gray);">
                    Transaction Fee:
                </span>
                <span class="font-semibold ml-10 font-mulish text-black text-lg">
                    ${{thankYouPageDataSignal()?.fee!.toFixed(2)}}
                </span>
            </div>

            <div class="flex justify-between items-center pt-6 ">
                <p class="text-xl font-bold font-mulish">
                    Total:
                </p>
                <span class="font-bold font-mulish text-black text-xl ">
                    ${{totalWithFee()}} {{currency()}}
                </span>
            </div>

        </div>

    </ng-template>

</p-dialog>